<template>
  <div class="share-browser" :class="{ isShow: bindShow && shareUrl }" @click="bindShow = false">
    <div class="title" @click.stop v-if="shareUrl">长按保存海报</div>
    <div class="poster-wrap" @click.stop>
      <PosterComponent :shareConfig="shareConfig" @getImage="val => imageUrl = val" />
    </div>
    <div class="operate-wrap" @click.stop v-if="shareUrl">
      <div class="operate-btn" @click="copyUrl">复制链接</div>
    </div>
  </div>
</template>

<script>
import PosterComponent from './poster';
import copy from 'clipboard-copy';
import { mapState } from 'vuex';
import bindShow from '@/mixins/bindShow';

export default {
  components: {
    PosterComponent
  },
  props: {
    shareConfig: Object
  },
  mixins: [
    bindShow
  ],
  data() {
    return {
      imageUrl: ''
    };
  },
  computed: {
    ...mapState({
      shareUrl: state => state.share.shareUrl
    })
  },
  methods: {
    copyUrl() {
      copy(this.shareUrl);
      this.$toast('复制成功，快去分享吧~');
    }
  }
};
</script>

<style lang="less" scoped>
.share-browser {
  position: fixed;
  z-index: 1000;
  top: -9999px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;

  &.isShow {
    top: 0;
  }

  .title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 16px;
  }

  .poster-wrap {
    margin-top: 20px;
  }

  .operate-wrap {
    margin-top: 20px;
    display: flex;
    align-items: center;

    .operate-btn {
      margin: 0 6px;
      background: #F65425;
      width: 240px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      border-radius: 24px;
      text-align: center;
    }
  }
}
</style>
